import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { StockPage } from './_dashboard.inventory.stock'

export const Route = createFileRoute('/_dashboard/inventory/stock/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: StockIndexPage,
})

function StockIndexPage() {
  return <StockPage selectedId={undefined} />
}
